import React from "react";

export default function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel = "Confirmer",
  cancelLabel = "Annuler",
  onConfirm,
  onCancel,
}) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[10000] grid place-items-center bg-black/75 px-4 backdrop-blur-sm">
      <section
        role="dialog"
        aria-modal="true"
        aria-labelledby="confirm-dialog-title"
        className="w-full max-w-md rounded-lg border border-white/15 bg-zinc-950 p-5 text-white shadow-2xl"
      >
        <h2 id="confirm-dialog-title" className="text-2xl font-black uppercase">
          {title}
        </h2>
        <p className="mt-3 text-sm leading-relaxed text-gray-300">{message}</p>
        <div className="mt-6 flex flex-col-reverse gap-3 sm:flex-row sm:justify-end">
          <button
            onClick={onCancel}
            className="rounded-full border border-white/15 px-5 py-2 text-sm font-bold uppercase transition hover:border-white"
          >
            {cancelLabel}
          </button>
          <button
            onClick={onConfirm}
            className="rounded-full bg-red-600 px-5 py-2 text-sm font-bold uppercase transition hover:bg-red-700"
          >
            {confirmLabel}
          </button>
        </div>
      </section>
    </div>
  );
}
